export enum actionTypes{
  'SET_SCHOOLS' = 'SET_SCHOOLS',
  'SET_DISCORDID' = 'SET_DISCORDID',
  'SET_GAMES' = 'SET_GAMES',
  'SET_USEROBJECT' = 'SET_USEROBJECT',
  'SET_EVENTS' = 'SET_EVENTS',
}

